import { createMuiTheme } from '@material-ui/core/styles';
import { ubuntuLight } from './importFonts';

export const themePrimary = (primary) => {
  // console.log(primary)
  return createMuiTheme({
    palette: {
      primary: {
        // light: will be calculated from palette.primary.main,
        main: primary,
        // dark: will be calculated from palette.primary.main,
        // contrastText: will be calculated to contrast with palette.primary.main
      },
      secondary: {
        light: '#0066ff',
        main: '#0044ff',
        // dark: will be calculated from palette.secondary.main,
        contrastText: '#ffcc00',
      },
      cancel: {
        // light: will be calculated from palette.primary.main,
        main: '#D40707',
        // dark: will be calculated from palette.primary.main,
        // contrastText: will be calculated to contrast with palette.primary.main
      },
      titles: {
          main: '#FFFFFF'
      },
      // Used by `getContrastText()` to maximize the contrast between
      // the background and the text.
      contrastThreshold: 3,
      // Used by the functions below to shift a color's luminance by approximately
      // two indexes within its tonal palette.
      // E.g., shift from Red 500 to Red 300 or Red 700.
      tonalOffset: 0.2,
    },
    typography: {
      fontFamily: 'UbuntuLight',
    },
    overrides: {
      MuiCssBaseline: {
        '@global': {
          '@font-face': [ubuntuLight],
        },
      },
      MuiButton: {
        containedSizeLarge : {
          fontSize: '0.6rem',
          color: '#1a1919',
          borderLeft: '3px solid rgba(255, 198, 0)',
          backgroundColor: "white",
          borderRadius: '0px',
          fontFamily: 'Ubuntu',
          fontWeight: 'bold',
          width : "200px",
          "&:hover": {
            backgroundColor: "#ffffff",
            borderLeft: '3px solid rgba(255, 198, 0)',
          }
        },
        containedPrimary : {
          fontSize: '0.6rem',
          color: '#1a1919',
          borderLeft: '3px solid rgba(255, 198, 0)',
          backgroundColor: "white",
          borderRadius: '0px',
          fontFamily: 'Ubuntu',
          fontWeight: 'bold',
          "&:hover": {
            backgroundColor: "#ffffff",
            borderLeft: '3px solid rgba(255, 198, 0)',
          }
        },
        containedSecondary : {
          fontSize: '0.6rem',
          color: 'white',
          backgroundColor: "#0097a0",
          borderRadius: '0px',
          fontFamily: 'Ubuntu',

          "&:hover": {
            backgroundColor: "#0097a0"
          }
        }
      }
      
    },
  })
}